

















































































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import useBreakPoints from "@/hooks/useBreakPoints";
import providers from "@/lib/api";
import config from "@/config";
import PageTitle from "@/components/PageTitle";
import SiteLogo from "@/components/SiteLogo";
import SocialLogin from "@/components/SocialLogin";

export default defineComponent({
  name: "LoginContainer",
  components: { SiteLogo, PageTitle, SocialLogin },
  props: {
    signup: { type: Boolean, default: true },
    title: { type: String, required: true },
    modalView: { type: Boolean, default: false },
  },
  setup(props) {
    const { isMobile, smallDesktopUp } = useBreakPoints();
    const pages = ref<Page[]>([]);

    const mobileView = computed(() => isMobile.value || props.modalView);

    const isSoloCreator = computed(() => !!config.soloCreatorId);

    const visibleLinks = computed(() =>
      pages.value.filter(
        (page: Page) =>
          page.visible &&
          (!props.signup || !["/static/privacy-policy.html", "/static/terms-of-use.html"].includes(page.path))
      )
    );
    const termsOfUse = computed<Page | undefined>(() => {
      return pages.value.find(p => p.path.includes("terms-of-use"));
    });
    const privacyPolicy = computed<Page | undefined>(() => {
      return pages.value.find(p => p.path.includes("privacy-policy"));
    });

    const getPages = async (): Promise<void> => {
      pages.value = await providers.PageProvider.find();
    };
    getPages();

    return {
      mobileView,
      smallDesktopUp,
      isSoloCreator,
      termsOfUse,
      visibleLinks,
      privacyPolicy,
    };
  },
});
